<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="d-flex align-items-center">
        <h4 class="mb-0">Comentarios</h4>
      </div>
    </div>
    <div class="row container-fluid">
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0" id="my-table-comments">
            <thead>
              <tr>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">
                  Nombre
                </th>
                <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 text-center">Correo
                  electronico
                </th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Teléfono
                </th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Mensaje
                </th>
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Fecha
                </th>
                <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Tipo
                </th> -->
                <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody v-if="comments">
              <tr v-for="comment in comments" :key="comment.id">
                <td>
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <small class="pe-2 text-wrap">{{ comment.name }}</small>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <small class="pe-3">{{ comment.email }}</small>
                  </div>
                </td>
                <td>
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <small class="pe-3">{{ comment.phone }}</small>
                  </div>
                </td>
                <!-- <td class="align-middle">
                  <div class="d-flex flex-column overflow-auto"  style=" max-height: 100px;">
                    <span class="text-secondary text-xs font-weight-bold text-wrap">{{ comment.message }}</span>
                  </div>
                </td> -->
                <td>
                  <button class="btn btn-link text-dark  px-3 mb-0" @click="showComentario(comment.message, comment.category)">
                    <i class="fas fa-comment text-dark me-2" aria-hidden="true"></i>
                    {{ comment.category === "Quejas" ? "Queja" : "Comentario" }}
                  </button>
                </td>
                <td class="align-middle text-center text-sm">
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <small class="pe-3">{{ dateSort(comment.created_at.split('T')[0]) }}</small>
                  </div>
                </td>
                <!-- <td class="align-middle text-center text-sm">
                  <div class="d-flex flex-column justify-content-center align-items-center">
                    <small class="pe-3">{{ comment.category }}</small>
                  </div>
                </td> -->
                <td class="align-middle">
                  <div class="text-center">
                    <button @click="enviarCorreo(comment.email)" class="btn btn-link text-primary  px-3 m-0">
                      <i class="far fa-comment-alt text-primary me-2" aria-hidden="true"></i>
                      Responder
                    </button>
                    <button @click="showAlert(comment.id)" class="btn btn-link text-danger text-gradient px-3 m-0">
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i>
                      Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import $ from 'jquery'
import 'datatables.net';
import 'datatables.net-dt/css/jquery.dataTables.css';

export default {
  name: "comment-table",
  props: {
    comments: {
      type: Array,
      request: true,
    },
  },
  mounted() {
    $('#my-table-comments').DataTable({
      ordering: false,
      pageLength: 50,
      lengthChange: false,
      language: {
        url: '//cdn.datatables.net/plug-ins/1.10.25/i18n/Spanish.json',
        pagingType: "simple_numbers",
        paginate: {
          previous: "<span class='pagination-link'>Anterior</span>",
          next: "<span class='pagination-link'>Siguiente</span>"
        },
      }
    });
  },
  methods: {
    deleteComment(commentID) {
      this.plain
        .delete(`/comments/${commentID}`)
        .then(() => {
          this.$parent.deleteItemComment(commentID)
          // console.log("COMENTARIO eliminado correctamente");
          // console.log(response.data);
        })
        .catch((error) => {
          console.log("Error al eliminar COMENTARIOS", error);
        });
    },
    enviarCorreo(email) {
      window.location.href = `mailto:${email}`;
    },
    dateSort(date) {
      const day = date.split('-')[2]
      const month = date.split('-')[1]
      const year = date.split('-')[0]
      return `${day}-${month}-${year}`
    },
    showAlert(commentID) {
      this.$swal.fire({
        title: '¿Está seguro?',
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteComment(commentID);
          this.$swal.fire(
            '¡Eliminado!',
            'El Comentario ha sido eliminado.',
            'De Acuerdo'
          )
        }
      })
    },
    showComentario(alertComment, category) {
      this.$swal.fire({
        title: category === "Quejas"? "Queja" : "Comentario",
        text: alertComment.length > 0 ? alertComment : 'Sin comentario...',
        confirmButtonText: 'Cerrar',
        showCloseButton: true
      })
    },
  }
};
</script>

<style>
.pagination-link {
  color: #083c74;
  font-family: 'Open Sans' !important;
}

.dataTables_info {
  color: #083c74 !important;
  font-family: 'Open Sans' !important;
}
</style>

  